var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.component(),{tag:"component",attrs:{"color":_vm.color,"left":_vm.left,"size":_vm.size,"small":_vm.small}},[_vm._v(" "+_vm._s(_setup.iconName())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }